import React, { useState } from "react";

import "./Gallery.css";

import image1 from "../../uploads/fidin img pdf_page-0008.jpg";
import image2 from "../../uploads/fidin img pdf_page-0009.jpg";
import image3 from "../../uploads/fidin img pdf_page-0010.jpg";
import image4 from "../../uploads/fidin img pdf_page-0006.jpg";

const Gallery = () => {

  const [filter, setFilter] = useState("all");

  const [lightbox, setLightbox] = useState(null);

  const galleryItems = [

    {
      image: image1,
      title: "Solar Plant Installation",
      category: "solar",
      date: "17 May 2026"
    },

    {
      image: image2,
      title: "Transmission Line Work",
      category: "transmission",
      date: "12 May 2026"
    },

    {
      image: image3,
      title: "Building Construction",
      category: "construction",
      date: "05 May 2026"
    },

    {
      image: image4,
      title: "Industrial Project",
      category: "industrial",
      date: "01 May 2026"
    }

  ];

  const filteredItems =
    filter === "all"
    ? galleryItems
    : galleryItems.filter(
        (item) => item.category === filter
      );

  return (

    <div className="gallery-page">

      {/* HERO */}

      <section className="gallery-hero">

        <h1>Project Gallery</h1>

        <p>
          Explore Our Completed Projects & Ongoing Work
        </p>

      </section>

      {/* GALLERY */}

      <section className="gallery-section">

        <div className="gallery-container">

          {/* FILTERS */}

          <div className="gallery-filter">

            <button
              className={filter === "all" ? "active" : ""}
              onClick={() => setFilter("all")}
            >
              All Projects
            </button>

            <button
              className={filter === "solar" ? "active" : ""}
              onClick={() => setFilter("solar")}
            >
              Solar Projects
            </button>

            <button
              className={filter === "transmission" ? "active" : ""}
              onClick={() => setFilter("transmission")}
            >
              Transmission
            </button>

            <button
              className={filter === "construction" ? "active" : ""}
              onClick={() => setFilter("construction")}
            >
              Construction
            </button>

            <button
              className={filter === "industrial" ? "active" : ""}
              onClick={() => setFilter("industrial")}
            >
              Industrial
            </button>

          </div>

          {/* GRID */}

          <div className="gallery-grid">

            {filteredItems.map((item, index) => (

              <div
                className="gallery-item"
                key={index}
                onClick={() => setLightbox(item.image)}
              >

                <img
                  src={item.image}
                  alt={item.title}
                />

                <div className="gallery-overlay">

                  <h3>{item.title}</h3>

                  <p>
                    Category: {item.category}
                  </p>

                  <p className="gallery-date">
                    {item.date}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* LIGHTBOX */}

      {lightbox && (

        <div
          className="lightbox"
          onClick={() => setLightbox(null)}
        >

          <span className="close-lightbox">
            &times;
          </span>

          <img
            src={lightbox}
            alt="Preview"
          />

        </div>

      )}

    </div>
  );
};

export default Gallery;